import React from 'react';
import AdminDashHeader from './AdminDashHeader';

const Ratings = () => {
  return (
    <div>
      <AdminDashHeader/>
      <h3>Ratings Functionality is coming</h3>
    </div>
  );
};

export default Ratings;